import { render, staticRenderFns } from "./RoleNameEdit.vue?vue&type=template&id=79843543&scoped=true&"
import script from "./RoleNameEdit.vue?vue&type=script&lang=js&"
export * from "./RoleNameEdit.vue?vue&type=script&lang=js&"
import style0 from "./RoleNameEdit.vue?vue&type=style&index=0&id=79843543&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79843543",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VRow,VTextField})
